import { Badge } from "@/components/ui/badge";
import { ExperimentStatus } from "@/types/enums";

export const EXPERIMENT_STATUS_LABELS: Record<ExperimentStatus, string> = {
  [ExperimentStatus.DRAFT]: "준비중",
  [ExperimentStatus.RUNNING]: "진행중",
  [ExperimentStatus.PAUSED]: "일시정지",
  [ExperimentStatus.COMPLETED]: "완료",
};

const STATUS_STYLES: Record<ExperimentStatus, string> = {
  [ExperimentStatus.DRAFT]: "bg-gray-100 text-gray-700 border-gray-200",
  [ExperimentStatus.RUNNING]: "bg-blue-100 text-blue-800 border-blue-200",
  [ExperimentStatus.PAUSED]: "bg-amber-100 text-amber-800 border-amber-200",
  [ExperimentStatus.COMPLETED]: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

const FALLBACK_CONFIG = {
  label: "알 수 없음",
  className: "bg-gray-100 text-gray-500 border-gray-200",
};

interface ExperimentStatusBadgeProps {
  status: ExperimentStatus;
}

export function ExperimentStatusBadge({ status }: ExperimentStatusBadgeProps) {
  const label = EXPERIMENT_STATUS_LABELS[status] ?? FALLBACK_CONFIG.label;
  const className = STATUS_STYLES[status] ?? FALLBACK_CONFIG.className;

  return (
    <Badge
      variant="outline"
      className={className}
      aria-label={`상태: ${label}`}
    >
      {label}
    </Badge>
  );
}
